import { api, tr } from './shared';

export function getB24Sections(lang) {
  return [
    {
      id: 'b24-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'Bitrix24 — обзор', 'Bitrix24 — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Интеграция Bitrix24 встраивает программу лояльности Loyalclub прямо в CRM. Менеджер видит баллы клиента в списке контактов и в карточке контакта, может начислить или списать баллы не покидая Битрикс24.',
            'The Bitrix24 integration embeds the Loyalclub loyalty program directly into the CRM. Managers see client points in the contact list and contact card, and can accrue or deduct points without leaving Bitrix24.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Что даёт интеграция', 'What the integration provides'),
          items: [
            tr(lang, 'Кастомное поле UF_LCL_POINTS в списке CRM-контактов — баллы видны без открытия карточки', 'Custom field UF_LCL_POINTS in the CRM contact list — points visible without opening the card'),
            tr(lang, 'Виджет в карточке контакта: баланс, история, кнопки начислить/списать', 'Widget in the contact card: balance, history, accrue/deduct buttons'),
            tr(lang, 'Автоматическая синхронизация UF_LCL_POINTS после каждой транзакции в Loyalclub', 'Automatic UF_LCL_POINTS sync after every Loyalclub transaction'),
            tr(lang, 'Автосоздание клиента Loyalclub при появлении нового контакта в Битрикс24 (webhook)', 'Auto-create Loyalclub client when a new contact appears in Bitrix24 (webhook)'),
            tr(lang, 'Поддержка всех типов карт: cashback, discount, stamp, subscription, certificate', 'Support for all card types: cashback, discount, stamp, subscription, certificate'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Архитектура', 'Architecture'),
          items: [
            tr(lang, 'Тип: локальное приложение Битрикс24 (OAuth 2.0)', 'Type: Bitrix24 local application (OAuth 2.0)'),
            tr(lang, 'Бэкенд интеграции: api.loyalclub.ru/b24/*', 'Integration backend: api.loyalclub.ru/b24/*'),
            tr(lang, 'Виджет регистрируется через placement.bind в карточке CRM-контакта', 'Widget is registered via placement.bind in the CRM contact card'),
            tr(lang, 'access_token обновляется автоматически (живёт 1 час)', 'access_token is refreshed automatically (lives 1 hour)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Base URL', 'Base URL'),
          items: [`${api.host}/b24`],
        },
      ],
    },
    {
      id: 'b24-setup',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navOrder: 5,
      navLabel: tr(lang, 'Настройка', 'Setup'),
      title: tr(lang, 'Bitrix24 — настройка', 'Bitrix24 — setup'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Порядок подключения', 'Connection steps'),
          items: [
            tr(lang, '1. Создайте интеграцию через POST /b24/integrations — получите api_key и install_url', '1. Create the integration via POST /b24/integrations — you will receive api_key and install_url'),
            tr(lang, '2. В Битрикс24 перейдите: Приложения → Разработчикам → Другое → Локальное приложение', '2. In Bitrix24 go to: Applications → For developers → Other → Local application'),
            tr(lang, '3. Установите install_url как путь обработчика', '3. Set the install_url as the handler path'),
            tr(lang, '4. Откройте install_url в браузере — создастся поле UF_LCL_POINTS и виджет зарегистрируется в CRM', '4. Open the install_url in the browser — the UF_LCL_POINTS field will be created and the widget will be registered in CRM'),
            tr(lang, '5. Виджет появится на вкладке карточки CRM-контакта', '5. The widget will appear on the CRM contact card tab'),
            tr(lang, '6. Настройка едина для всей организации — одна интеграция покрывает все карты лояльности организации', '6. One integration covers all loyalty cards of the organization'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Что происходит при открытии install_url', 'What happens when opening install_url'),
          items: [
            tr(lang, 'Битрикс24 передаёт OAuth-токен, который сохраняется в БД', 'Bitrix24 passes an OAuth token which is saved to the database'),
            tr(lang, 'Создаётся кастомное поле UF_LCL_POINTS в контактах CRM', 'Custom field UF_LCL_POINTS is created in CRM contacts'),
            tr(lang, 'Через placement.bind виджет регистрируется в карточке контакта', 'The widget is registered in the contact card via placement.bind'),
            tr(lang, 'Вызывается app.install.finish для завершения установки', 'app.install.finish is called to complete the installation'),
          ],
        },
      ],
    },
    {
      id: 'b24-integration-create',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: tr(lang, 'Создать интеграцию', 'Create integration'),
      title: 'POST /b24/integrations',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Создаёт интеграцию с Битрикс24 для организации. Возвращает api_key и install_url, который нужно указать в настройках локального приложения Битрикс24.',
            'Creates a Bitrix24 integration for the organization. Returns api_key and install_url to be configured in the Bitrix24 local application settings.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'list',
          title: tr(lang, 'Коды ответов', 'Response codes'),
          items: [
            tr(lang, '200 — успешно, возвращает api_key и install_url', '200 — success, returns api_key and install_url'),
            tr(lang, '401 — не авторизован', '401 — unauthorized'),
            tr(lang, '409 — интеграция для организации уже существует', '409 — integration for this organization already exists'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'b24-int-create',
          value: `curl -X POST "${api.host}/b24/integrations" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'b24-int-create-resp',
          value: `{\n  "id": 3,\n  "organization_id": 42,\n  "api_key": "b24_abc123...",\n  "install_url": "${api.host}/b24/install?key=b24_abc123...",\n  "is_active": true,\n  "b24_domain": null,\n  "created_at": "2024-03-17T10:00:00Z"\n}`,
        },
      ],
    },
    {
      id: 'b24-integrations-list',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 20,
      navLabel: tr(lang, 'Список интеграций', 'List integrations'),
      title: 'GET /b24/integrations',
      blocks: [
        { type: 'text', value: tr(lang, 'Возвращает список интеграций Битрикс24 для организации.', 'Returns the list of Bitrix24 integrations for the organization.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'code',
          title: 'curl',
          key: 'b24-int-list',
          value: `curl -X GET "${api.host}/b24/integrations" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'b24-integration-update',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 30,
      navLabel: tr(lang, 'Обновить интеграцию', 'Update integration'),
      title: 'PUT /b24/integrations/{id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Обновляет настройки интеграции (is_active и settings).', 'Updates integration settings (is_active and settings).') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['id (int) — ID интеграции'] },
        {
          type: 'code',
          title: 'curl',
          key: 'b24-int-update',
          value: `curl -X PUT "${api.host}/b24/integrations/3" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{"is_active": true}'`,
        },
      ],
    },
    {
      id: 'b24-integration-delete',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 40,
      navLabel: tr(lang, 'Удалить интеграцию', 'Delete integration'),
      title: 'DELETE /b24/integrations/{id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Удаляет интеграцию и все связанные ссылки контактов.', 'Deletes the integration and all linked contact links.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['id (int) — ID интеграции'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — удалено', '200 — deleted'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'b24-int-delete',
          value: `curl -X DELETE "${api.host}/b24/integrations/3" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'b24-install',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Приложение Битрикс24', 'Bitrix24 application'),
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: tr(lang, 'Страница установки', 'Install page'),
      title: 'GET /b24/install?key={api_key}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Страница установки локального приложения. Вызывается Битрикс24 при установке. Создаёт кастомное поле UF_LCL_POINTS и регистрирует виджет в CRM через placement.bind.',
            'Local application install page. Called by Bitrix24 during installation. Creates the UF_LCL_POINTS custom field and registers the widget in CRM via placement.bind.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Что происходит при вызове', 'What happens on call'),
          items: [
            tr(lang, '1. OAuth-токены сохраняются из POST-параметров Битрикс24', '1. OAuth tokens are saved from Bitrix24 POST parameters'),
            tr(lang, '2. Через crm.userfield.add создаётся поле UF_LCL_POINTS (если ещё нет)', '2. UF_LCL_POINTS field is created via crm.userfield.add (if not exists)'),
            tr(lang, '3. Через placement.bind виджет регистрируется в CRM_CONTACT_DETAIL_TAB', '3. Widget is registered in CRM_CONTACT_DETAIL_TAB via placement.bind'),
            tr(lang, '4. Через event.bind настраивается webhook ONCRMCONTACTADD', '4. ONCRMCONTACTADD webhook is configured via event.bind'),
            tr(lang, '5. Вызывается app.install.finish', '5. app.install.finish is called'),
          ],
        },
        { type: 'list', title: tr(lang, 'Параметры', 'Parameters'), items: [tr(lang, 'key (string, в URL) — api_key интеграции', 'key (string, in URL) — integration api_key')] },
      ],
    },
    {
      id: 'b24-widget',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Приложение Битрикс24', 'Bitrix24 application'),
      navSubgroupOrder: 20,
      navOrder: 20,
      navLabel: tr(lang, 'Виджет', 'Widget'),
      title: 'GET /b24/widget?key={api_key}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Возвращает HTML страницы виджета, которая отображается в iframe внутри карточки CRM-контакта. Использует BX24.js SDK для получения данных контакта и обращается к Loyalclub Public API для получения данных лояльности.',
            'Returns the HTML of the widget page displayed in an iframe inside the CRM contact card. Uses the BX24.js SDK to get contact data and calls the Loyalclub Public API to retrieve loyalty data.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Что показывает виджет', 'What the widget shows'),
          items: [
            tr(lang, 'cashback — баланс баллов, процент кэшбэка, уровень статуса', 'cashback — point balance, cashback percent, status level'),
            tr(lang, 'discount — размер скидки, сумма покупок для следующего уровня', 'discount — discount size, purchases needed for next tier'),
            tr(lang, 'stamp — число штампов / всего нужно, число наград', 'stamp — stamps / total needed, number of rewards'),
            tr(lang, 'subscription — визитов использовано / всего по подписке', 'subscription — visits used / total in subscription'),
            tr(lang, 'certificate — баланс сертификата, номер', 'certificate — certificate balance, number'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Кнопки действий', 'Action buttons'),
          items: [
            tr(lang, '"Начислить" — открывает форму начисления баллов/штампов', '"Accrue" — opens the accrual form'),
            tr(lang, '"Списать" — открывает форму списания баллов', '"Deduct" — opens the deduction form'),
            tr(lang, 'Форма принимает сумму или количество и отправляет транзакцию через Public API', 'Form accepts amount or count and sends a transaction via Public API'),
          ],
        },
      ],
    },
    {
      id: 'b24-loyalty-field',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Поле UF_LCL_POINTS', 'UF_LCL_POINTS field'),
      navSubgroupOrder: 30,
      navOrder: 10,
      navLabel: 'UF_LCL_POINTS',
      title: tr(lang, 'Bitrix24 — поле UF_LCL_POINTS', 'Bitrix24 — UF_LCL_POINTS field'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Кастомное строковое поле в объекте CRM Contact. Отображается прямо в списке контактов без открытия виджета. Обновляется автоматически после каждой транзакции в Loyalclub Public API и при ручной синхронизации.',
            'Custom string field in the CRM Contact object. Displayed directly in the contact list without opening the widget. Updated automatically after every Loyalclub Public API transaction and on manual sync.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Формат значения по типу карты', 'Field value format by card type'),
          items: [
            tr(lang, 'cashback — "500 баллов | gold"', 'cashback — "500 pts | gold"'),
            tr(lang, 'discount — "Скидка 7% | silver"', 'discount — "Discount 7% | silver"'),
            tr(lang, 'stamp — "3/10 штампов | 1 нагр."', 'stamp — "3/10 stamps | 1 rew."'),
            tr(lang, 'subscription — "4/10 визитов"', 'subscription — "4/10 visits"'),
            tr(lang, 'certificate — "Сертификат 1500 руб."', 'certificate — "Certificate 1500 rub."'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Когда обновляется', 'When updated'),
          items: [
            tr(lang, 'После каждой транзакции через POST /api/v1/transactions (асинхронно)', 'After every transaction via POST /api/v1/transactions (asynchronously)'),
            tr(lang, 'При ручной синхронизации через POST /b24/integrations/{id}/sync-points', 'On manual sync via POST /b24/integrations/{id}/sync-points'),
          ],
        },
      ],
    },
    {
      id: 'b24-sync-points',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Поле UF_LCL_POINTS', 'UF_LCL_POINTS field'),
      navSubgroupOrder: 30,
      navOrder: 20,
      navLabel: tr(lang, 'Синхронизация баллов', 'Sync points'),
      title: 'POST /b24/integrations/{id}/sync-points',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Вручную синхронизирует поле UF_LCL_POINTS для всех связанных контактов. Используйте при первоначальном подключении или если данные могли рассинхронизироваться.',
            'Manually synchronizes the UF_LCL_POINTS field for all linked contacts. Use during initial setup or if data may have gone out of sync.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['id (int) — ID интеграции'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — возвращает synced и errors', '200 — returns synced and errors'), tr(lang, '404 — интеграция не найдена', '404 — integration not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'b24-sync',
          value: `curl -X POST "${api.host}/b24/integrations/3/sync-points" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'b24-sync-resp',
          value: `{\n  "synced": 47,\n  "errors": 2,\n  "error_details": [\n    {"b24_contact_id": "123", "error": "Contact not found in B24"}\n  ]\n}`,
        },
      ],
    },
    {
      id: 'b24-webhook',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navSubgroup: tr(lang, 'Webhook', 'Webhook'),
      navSubgroupOrder: 40,
      navOrder: 10,
      navLabel: tr(lang, 'Webhook ONCRMCONTACTADD', 'ONCRMCONTACTADD webhook'),
      title: 'POST /b24/webhook',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Обрабатывает событие ONCRMCONTACTADD от Битрикс24 — создание нового контакта в CRM. При наличии телефона у контакта автоматически создаётся клиент в Loyalclub (если такого нет) и сохраняется связь в bitrix24_contact_links.',
            'Handles ONCRMCONTACTADD event from Bitrix24 — a new CRM contact is created. If the contact has a phone number, a Loyalclub client is automatically created (if not exists) and a link is saved in bitrix24_contact_links.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Что происходит', 'What happens'),
          items: [
            tr(lang, '1. Битрикс24 отправляет event с данными нового контакта', '1. Bitrix24 sends an event with new contact data'),
            tr(lang, '2. Проверяется application_token для безопасности', '2. application_token is validated for security'),
            tr(lang, '3. По телефону ищется или создаётся клиент Loyalclub', '3. Loyalclub client is found or created by phone'),
            tr(lang, '4. Сохраняется запись в bitrix24_contact_links (b24_contact_id ↔ client_id)', '4. Record is saved in bitrix24_contact_links (b24_contact_id ↔ client_id)'),
          ],
        },
        { type: 'list', title: tr(lang, 'Авторизация', 'Authorization'), items: [tr(lang, 'Не требуется. Верифицируется по application_token в теле запроса.', 'Not required. Verified by application_token in the request body.')] },
        {
          type: 'code',
          title: tr(lang, 'Пример тела от Битрикс24', 'Example body from Bitrix24'),
          key: 'b24-webhook-body',
          value: `{\n  "event": "ONCRMCONTACTADD",\n  "application_token": "abc123token",\n  "data": {\n    "FIELDS": {\n      "ID": "456",\n      "NAME": "Иван",\n      "LAST_NAME": "Иванов",\n      "PHONE": [{ "VALUE": "+79001234567", "VALUE_TYPE": "WORK" }]\n    }\n  }\n}`,
        },
      ],
    },
    {
      id: 'b24-errors',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navOrder: 85,
      navLabel: tr(lang, 'Форматы ошибок', 'Error formats'),
      title: tr(lang, 'Bitrix24 — форматы ошибок', 'Bitrix24 — error formats'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Loyalclub API и Битрикс24 REST API используют разные форматы ошибок. Loyalclub возвращает HTTP-статус 4xx с JSON-телом. Битрикс24 REST API всегда возвращает HTTP 200, а ошибка описана в поле error внутри тела ответа.',
            'The Loyalclub API and Bitrix24 REST API use different error formats. Loyalclub returns HTTP 4xx status with a JSON body. Bitrix24 REST API always returns HTTP 200, with the error described in the error field inside the response body.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Loyalclub API — коды HTTP-ошибок', 'Loyalclub API — HTTP error codes'),
          items: [
            tr(lang, '400 — неверный запрос (ошибка валидации)', '400 — bad request (validation error)'),
            tr(lang, '401 — не авторизован (токен отсутствует или невалиден)', '401 — unauthorized (token missing or invalid)'),
            tr(lang, '403 — нет доступа (операция запрещена для пользователя)', '403 — forbidden (operation not allowed for this user)'),
            tr(lang, '404 — ресурс не найден', '404 — resource not found'),
            tr(lang, '409 — конфликт (интеграция уже существует)', '409 — conflict (integration already exists)'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Loyalclub API — ошибка 401', 'Loyalclub API — 401 error'),
          key: 'b24-err-401',
          value: `HTTP/1.1 401 Unauthorized\n\n{\n  "detail": "Not authenticated"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Loyalclub API — ошибка 409', 'Loyalclub API — 409 error'),
          key: 'b24-err-409',
          value: `HTTP/1.1 409 Conflict\n\n{\n  "detail": "Bitrix24 integration for this organization already exists"\n}`,
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Битрикс24 REST API возвращает HTTP 200 даже при ошибке. Проверяйте наличие поля error в ответе перед обработкой result.',
            'Bitrix24 REST API returns HTTP 200 even on error. Always check for the error field in the response before processing result.',
          ),
        },
        {
          type: 'code',
          title: tr(lang, 'Битрикс24 API — ошибка (HTTP 200)', 'Bitrix24 API — error (HTTP 200)'),
          key: 'b24-err-b24-generic',
          value: `HTTP/1.1 200 OK\n\n{\n  "error": "ACCESS_DENIED",\n  "error_description": "Access denied! Application context required"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Битрикс24 API — истёк токен (HTTP 200)', 'Bitrix24 API — expired token (HTTP 200)'),
          key: 'b24-err-b24-token',
          value: `HTTP/1.1 200 OK\n\n{\n  "error": "expired_token",\n  "error_description": "The access token provided has expired"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Битрикс24 API — rate limit (HTTP 200)', 'Bitrix24 API — rate limit (HTTP 200)'),
          key: 'b24-err-b24-ratelimit',
          value: `HTTP/1.1 200 OK\n\n{\n  "error": "QUERY_LIMIT_EXCEEDED",\n  "error_description": "Too many requests"\n}`,
        },
        {
          type: 'list',
          title: tr(lang, 'Типичные error-коды Битрикс24 REST', 'Common Bitrix24 REST error codes'),
          items: [
            tr(lang, 'ACCESS_DENIED — нет прав на вызов метода (нужен application context)', 'ACCESS_DENIED — no permission to call the method (application context required)'),
            tr(lang, 'expired_token — access_token истёк, Loyalclub автоматически обновит его', 'expired_token — access_token expired, Loyalclub will refresh it automatically'),
            tr(lang, 'QUERY_LIMIT_EXCEEDED — превышен rate limit (2–10 rps в зависимости от тарифа)', 'QUERY_LIMIT_EXCEEDED — rate limit exceeded (2–10 rps depending on plan)'),
            tr(lang, 'NOT_FOUND — контакт или поле не найдено', 'NOT_FOUND — contact or field not found'),
            tr(lang, 'WRONG_AUTH_TYPE — токен не подходит для данного метода', 'WRONG_AUTH_TYPE — token not suitable for this method'),
          ],
        },
      ],
    },
    {
      id: 'b24-limits',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'Bitrix24',
      navGroupOrder: 40,
      navOrder: 90,
      navLabel: tr(lang, 'Ограничения API', 'API limits'),
      title: tr(lang, 'Bitrix24 — ограничения API', 'Bitrix24 — API limits'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Rate limits Битрикс24 REST API', 'Bitrix24 REST API rate limits'),
          items: [
            tr(lang, 'Бесплатный / Базовый тариф: 2 запроса в секунду', 'Free / Basic plan: 2 requests per second'),
            tr(lang, 'Стандарт / Профессиональный: до 10 запросов в секунду', 'Standard / Professional: up to 10 requests per second'),
            tr(lang, 'При превышении — HTTP 429 (Too Many Requests)', 'Exceeded limit — HTTP 429 (Too Many Requests)'),
            tr(lang, 'Синхронизация баллов выполняется последовательно с задержками для соблюдения лимитов', 'Points sync is performed sequentially with delays to respect rate limits'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'access_token', 'access_token'),
          items: [
            tr(lang, 'Время жизни: 1 час', 'Lifetime: 1 hour'),
            tr(lang, 'Обновляется автоматически при первом запросе после истечения', 'Refreshed automatically on the first request after expiry'),
            tr(lang, 'Используется refresh_token (живёт 60 дней)', 'refresh_token is used (lives 60 days)'),
            tr(lang, 'Если refresh_token истёк — потребуется переустановка приложения', 'If refresh_token expires — application reinstallation is required'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Рекомендации', 'Recommendations'),
          items: [
            tr(lang, 'При массовой синхронизации используйте endpoint sync-points, а не ручные запросы', 'For bulk sync use the sync-points endpoint, not manual requests'),
            tr(lang, 'Транзакции автоматически обновляют поле — ручная синхронизация нужна только при первом подключении', 'Transactions auto-update the field — manual sync only needed at initial setup'),
          ],
        },
      ],
    },
  ];
}
